import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';

const getBearerToken = () => {
    return Cookies.get('auth_token');
};

export const skinDashboardApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_URL}`,
        prepareHeaders(headers) {
            const token = getBearerToken();
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),

    endpoints: (builder) => ({
        // skin
        fetchAnalyticsData: builder.query({
            query: ({ type, storeNumbers, startDate, endDate, platform }) =>
                `analytics/${type}/Dashboard?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}${platform ? `&platform=${platform}` : ""}`,
        }),

        getProfile: builder.query({
            query: () => 'admin/getProfile',
        }),
        getUserFeedback: builder.query({
            query: ({ storeNumbers, type }) => `admin/userFeedback?storeNumbers=${storeNumbers}&feedbackOf=${type}`,
        }),
        getLiveSkus: builder.query({
            query: () => 'admin/getLiveSkus',
        }),
        fetchTotalUsers: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/totalUsers?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalSessions: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/totalSessions?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalUserDropCount: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/skin/totalUserDropCount?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalAvgMinutes: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/totalAvgMinutes?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalTopTen: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/skin/totalTopTen?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalSmsWhatsapp: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/totalSmsWhatsapp?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchAddToCart: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/totalCart?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalRecommendation: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/totalRecommendation?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalSkinConcern: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/total${type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()}Concern?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalAgeGroup: builder.query({
            query: ({ type, storeNumbers, startDate, endDate }) =>
                `analytics/${type}/totalAgeGroup?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchTotalSkinType: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/skin/totalSkinType?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        getMirrorStatus: builder.query({
            query: () => 'admin/getMirrosStatus',
        }),

        //makeup
        fetchMakeupTotalUsers: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/makeup/totalUser?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchMakeupTotalWishlistLook: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/makeup/totalWishlistLook?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchMakeupTop20: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/makeup/top20?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchMakeupAvgPresentMakeup: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/makeup/avgPresentMakeup?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
        fetchMakeupTotalUserDistribution: builder.query({
            query: ({ storeNumbers, startDate, endDate }) =>
                `analytics/makeup/totalUserDis?storeNumbers=${storeNumbers}&startDate=${startDate}&endDate=${endDate}`,
        }),
    }),
});

export const {
    useFetchAnalyticsDataQuery,
    useGetProfileQuery,
    useGetUserFeedbackQuery,
    useGetLiveSkusQuery,
    useGetMirrorStatusQuery,
    useFetchTotalUsersQuery,
    useFetchTotalSessionsQuery,
    useFetchTotalUserDropCountQuery,
    useFetchTotalAvgMinutesQuery,
    useFetchTotalTopTenQuery,
    useFetchTotalSmsWhatsappQuery,
    useFetchTotalRecommendationQuery,
    useFetchTotalSkinConcernQuery,
    useFetchTotalAgeGroupQuery,
    useFetchTotalSkinTypeQuery,
    useFetchAddToCartQuery,
    useFetchMakeupAvgPresentMakeupQuery,
    useFetchMakeupTop20Query,
    useFetchMakeupTotalUserDistributionQuery,
    useFetchMakeupTotalUsersQuery,
    useFetchMakeupTotalWishlistLookQuery,
} = skinDashboardApi;